<mat-card-content class="content-card-descriptions" (click)="navigateTo(car)">

  <div class="img-container">

    <img [src]="summaryService.imgCarCard(car)" alt="car image" loading="lazy">
    <mat-divider></mat-divider>

  </div>

  <div class="car-description">
    <h5 class="h5-desc"><span class="brand"> {{car.brand }} {{car.subBrand }} </span> | {{car.version}}
      {{car.year}}</h5>
  </div>

  <div>
    <p class="desde"> Desde </p>
    <span class="price"> ${{(car.rentingMin) | number : '1.2'}} </span> <span class="men">MXN mensuales
    </span><span class="point color-bitcar"> * </span>
  </div>


  <div class="container-specs">

    <div [ngSwitch]="car.powerTrain">
      <div *ngSwitchCase="'Gasolina'"><mat-icon svgIcon="spec-gasolina" aria-hidden="false" aria-label="fb"></mat-icon>
        {{car.powerTrain}}</div>
      <div *ngSwitchCase="'Híbrido'"><mat-icon svgIcon="spec-hibrido" aria-hidden="false" aria-label="fb"></mat-icon>
        {{car.powerTrain}}</div>
      <div *ngSwitchCase="'Eléctrico'"><mat-icon svgIcon="spec-electrico" aria-hidden="false"
          aria-label="fb"></mat-icon> {{car.powerTrain}}</div>
    </div>
    <div [ngSwitch]="car.transmission">
      <div *ngSwitchCase="'Automática'"><mat-icon svgIcon="spec-automatica" aria-hidden="false"
          aria-label="fb"></mat-icon> {{car.transmission}}</div>
      <div *ngSwitchCase="'Manual'"><mat-icon svgIcon="spec-manual" aria-hidden="false" aria-label="fb"></mat-icon>
        {{car.transmission}}</div>
    </div>

  </div>

</mat-card-content>